import { useEffect, useState } from 'react';

import { getMyOrganization } from '../../../api/organizationApi';
import { useAuth } from '../../../contexts/AuthContext';

const useSchoolAdminOrg = () => {
  const { currentUser } = useAuth();
  const [state, setState] = useState({ loading: true, orgId: null, orgName: '', schoolLevel: '', error: '' });

  useEffect(() => {
    let cancelled = false;
    if (!currentUser) return undefined;
    getMyOrganization(currentUser)
      .then((mine) => {
        if (cancelled) return;
        const org = mine?.organization;
        const isAdmin = org?.role === 'admin';
        setState({
          loading: false,
          orgId: isAdmin ? org.id : null,
          orgName: isAdmin ? org.name || '' : '',
          schoolLevel: isAdmin ? org.school_level || '' : '',
          error: '',
        });
      })
      .catch((error) => {
        if (!cancelled) setState({ loading: false, orgId: null, orgName: '', schoolLevel: '', error: error.message });
      });
    return () => {
      cancelled = true;
    };
  }, [currentUser]);

  return { ...state, currentUser };
};

export default useSchoolAdminOrg;
